import { useContext } from "react";
import { useLocation, Outlet } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";
import NotFound from "../modules/swiftboard/not-found/page";

export default function ModuleRouteGuard() {
    const { allowedPaths, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) return null; 

    const currentPath = location.pathname; 
    if (
        allowedPaths.some(path => currentPath.startsWith(path)) 
    ) {
        return <Outlet />
    }

    return <NotFound />;
} 